<table>
    <thead>
        <th class="subtable string">{{'global.pais' | translate}}</th>
        <th class="subtable string">{{'mantenimiento-entidades-control.denominaciones.denominacion' | translate}}</th>
        <th class="subtable icon">{{'global.etiquetaDigital' | translate}}</th>
        <th class="subtable action">
            <i class="fas fa-plus" (click)="newPaisDenominacion()" title="{{'mantenimiento-entidades-control.denominaciones.tituloNew' | translate}}"></i>
        </th>
    </thead>
    <tbody>
        <app-mec-pais-denominacion-new-edit class="component-in-row" *ngIf="new" [creating]="true" [entidadControlId]="entidadControlId" (close)="new=$event" [paises]="paises"
        (refresh)="toRefresh($event)" (pushMessage)="pushMessage.emit($event)" (editableChanged)="editableChanged($event)"></app-mec-pais-denominacion-new-edit>
        <app-mec-pais-denominacion-new-edit class="component-in-row" *ngFor="let paisDenominacion of paisDenominacionList" [creating]="false" [editing]="paisDenominacionEditable === paisDenominacion"[entidadControlId]="entidadControlId"
         [entidadControlPaisDenominacion]="paisDenominacion" (pushMessage)="pushMessage.emit($event)" (close)="new=$event" [paises]="paises" (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"></app-mec-pais-denominacion-new-edit>
    </tbody>
    <tfoot *ngIf="paisDenominacionList && paisDenominacionList.length < 1 && !new">
        <tr>
          <td colspan="7">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>
<app-paginator *ngIf="paisDenominacionList && paisDenominacionList.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
    (pageChange)="pageChange($event)"></app-paginator>
